import styles from "../SpellChecker.module.css";
import React from "react";

let Element = _props => <span className={ styles.recognized }>{ _props.children }</span>
export default Element